import React from 'react';
import classNames from 'classnames';

export default function WeddingIcon({ className = '' }) {
	return <span className={classNames('icon icon-weddings', className)} />;
}
